import React from 'react';

import { monthNames, mountInterval } from '@src/common/calendar';
import useTranslate from '@src/i18n/useTranslate';
import {
  Container,
  YearlyViewMonthArea,
  YearlyViewMonthAreaInner,
  YearlyViewMonthName,
  YearViewSingleMonth,
  YearViewSingleMonthDay,
} from './styles';

interface CalendarYearViewProps {
  year: number;
  onMonthClick: (month: [number, number]) => void;
}

const CalendarYearView = (props: CalendarYearViewProps) => {
  const { year, onMonthClick } = props;

  const { i18n } = useTranslate();

  return (
    <Container>
      {monthNames.map((month, index) => (
        <YearlyViewMonthArea key={index} onClick={() => onMonthClick([year, index + 1])}>
          <YearlyViewMonthAreaInner>
            <YearlyViewMonthName>{i18n(month)}</YearlyViewMonthName>

            <YearViewSingleMonth>
              {mountInterval([year, index + 1]).map((interval) => (
                <YearViewSingleMonthDay key={interval.dateString} isVisible={interval.month == index + 1} />
              ))}
            </YearViewSingleMonth>
          </YearlyViewMonthAreaInner>
        </YearlyViewMonthArea>
      ))}
    </Container>
  );
};

export default CalendarYearView;
